import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { Formalite } from '@europrocurement/l2d-domain/reducers/formalites/slices/formalite';
import { useDispatch } from 'react-redux';
import { todoIcon } from '@europrocurement/l2d-icons';
import { useFormaliteService } from '@europrocurement/l2d-domain';
import { AnyAction } from '@reduxjs/toolkit';
import useFormalityFormHandler from '../../hooks/useFormalityFormHandler';
import CardTitle from '../../components/CardTitle';
import ActionButton from '../../components/ActionButton';
import FormalityValidatorsCard from './FormalityValidatorsCard';
import ValidatorsModal from './ValidatorsModal';

type FormalityValidatorsTabProps = {
    formality: Formalite;
};

const FormalityValidatorsTab: React.FunctionComponent<FormalityValidatorsTabProps> = function (
    props,
) {
    const { selectFormality } = useFormaliteService();

    const { formality } = props;
    const [editModalOpen, setEditModalOpen] = useState(false);
    const { updateFormality } = useFormalityFormHandler();
    const dispatch = useDispatch();

    const onOpenModal = () => {
        setEditModalOpen(true);
    };
    const onCloseModal = () => {
        setEditModalOpen(false);
    };
    const onEditModal = (selectedItems: (string | number)[]) => {
        updateFormality(formality, { validators: selectedItems as string[] }).then(() => {
            dispatch(
                selectFormality({ id: formality.id as unknown as string }) as unknown as AnyAction,
            );
        });
    };

    return (
        <>
            <Grid container>
                <Grid
                    item
                    xs={12}
                    md={10}
                >
                    <CardTitle title="Liste des valideurs associées" />
                </Grid>
                <Grid
                    item
                    xs={12}
                    md={2}
                >
                    <ActionButton
                        label="Modifier la liste"
                        onClick={onOpenModal}
                        icon={todoIcon}
                    />
                </Grid>
                <Grid
                    item
                    xs={12}
                >
                    <FormalityValidatorsCard
                        formality={formality}
                        onUpdateValidators={onEditModal}
                    />
                </Grid>
            </Grid>
            <ValidatorsModal
                isOpen={editModalOpen}
                onModalClose={onCloseModal}
                onSubmitModal={onEditModal}
                itemsSelected={formality.validators as unknown[] as number[]}
            />
        </>
    );
};

export default FormalityValidatorsTab;
